import { loadingTimeFrame } from '../components/constants';

export const getLoadingTimeFrame = (playersNum: number) => {
  switch (true) {
    case playersNum >= 4 && playersNum < 8:
      return 500; // 200

    case playersNum >= 8:
      return 300; // 120

    default:
      return 1000; // loadingTimeFrame;
  }
};

